/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_ElectronicClocks_DisplayBrightnessModel } from '../models/BigClock_Api_Models_ElectronicClocks_DisplayBrightnessModel';
import type { BigClock_Api_Models_ElectronicClocks_MeteoModel } from '../models/BigClock_Api_Models_ElectronicClocks_MeteoModel';
import type { BigClock_Api_Models_ElectronicClocks_ScreenDelayModel } from '../models/BigClock_Api_Models_ElectronicClocks_ScreenDelayModel';
import type { BigClock_Api_Models_LedPanels_LedPanelClockStyleModel } from '../models/BigClock_Api_Models_LedPanels_LedPanelClockStyleModel';
import type { BigClock_Api_Models_LedPanels_LedPanelColorModel } from '../models/BigClock_Api_Models_LedPanels_LedPanelColorModel';
import type { BigClock_Api_Models_LedPanels_LedPanelDotModeModel } from '../models/BigClock_Api_Models_LedPanels_LedPanelDotModeModel';
import type { BigClock_Api_Models_LedPanels_LedPanelOperatingModeModel } from '../models/BigClock_Api_Models_LedPanels_LedPanelOperatingModeModel';
import type { BigClock_Api_Models_SetDeviceSourceModel } from '../models/BigClock_Api_Models_SetDeviceSourceModel';
import type { BigClock_Api_Models_StateModel } from '../models/BigClock_Api_Models_StateModel';
import type { BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse } from '../models/BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse';
import type { BigClock_Application_Queries_ReadLedPanelParams_ReadLedPanelParamsResponse } from '../models/BigClock_Application_Queries_ReadLedPanelParams_ReadLedPanelParamsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LedPanelService {
    /**
     * @param ledPanelId
     * @returns BigClock_Application_Queries_ReadLedPanelParams_ReadLedPanelParamsResponse Success
     * @throws ApiError
     */
    public static getApiLedPanelParams(
        ledPanelId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadLedPanelParams_ReadLedPanelParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/LedPanel/{ledPanelId}/params',
            path: {
                'ledPanelId': ledPanelId,
            },
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelOperatingMode(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_LedPanels_LedPanelOperatingModeModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/operating-mode',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelClockStyle(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_LedPanels_LedPanelClockStyleModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/clock-style',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelClockColor(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_LedPanels_LedPanelColorModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/clock-color',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelHeaderColor(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_LedPanels_LedPanelColorModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/header-color',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelFooterColor(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_LedPanels_LedPanelColorModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/footer-color',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelDotMode(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_LedPanels_LedPanelDotModeModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/dot-mode',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelDisplayState(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/display/state',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelDisplayBrightness(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_ElectronicClocks_DisplayBrightnessModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/display/brightness',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @returns BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse Success
     * @throws ApiError
     */
    public static getApiLedPanelWorkdays(
        ledPanelId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetElectronicClockWorkdays_GetElectronicClockWorkdaysResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/LedPanel/{ledPanelId}/workdays',
            path: {
                'ledPanelId': ledPanelId,
            },
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelScreenDelay(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_ElectronicClocks_ScreenDelayModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/screen-delay',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelSerialState(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_StateModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/serial/state',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelMeteo(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_ElectronicClocks_MeteoModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/meteo',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ledPanelId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static postApiLedPanelMeteoSource(
        ledPanelId: string,
        requestBody?: BigClock_Api_Models_SetDeviceSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/LedPanel/{ledPanelId}/meteo-source',
            path: {
                'ledPanelId': ledPanelId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
